import { render, staticRenderFns } from "./AppMainScreenMerchant.vue?vue&type=template&id=29bc0be0&scoped=true&"
import script from "./AppMainScreenMerchant.vue?vue&type=script&lang=js&"
export * from "./AppMainScreenMerchant.vue?vue&type=script&lang=js&"
import style0 from "./AppMainScreenMerchant.vue?vue&type=style&index=0&id=29bc0be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc0be0",
  null
  
)

export default component.exports